import client from "../Client/HttpClient";
import { ICompetencyPeriodAssignmentsModel } from "@/interfaces/modules";

const ApiPath = "CompetencyPeriodAssignments";

export default {
  /** GET api/CompetencyPeriodAssignments */
  GetAll: (): Promise<ICompetencyPeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/CompetencyPeriodAssignments/{id} */
  GetById: (id: number): Promise<ICompetencyPeriodAssignmentsModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/CompetencyPeriodAssignments/byCompetency/{competencyId} */
  GetByCompetencyId: (competencyId: number): Promise<ICompetencyPeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}/byCompetency/${competencyId}`),

  /** GET api/CompetencyPeriodAssignments/byPeriod/{periodId} */
  GetByPeriodId: (periodId: number): Promise<ICompetencyPeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}/byPeriod/${periodId}`),

  /**
   * POST api/CompetencyPeriodAssignments
   * Creates/updates one assignment (controller’s Save action).
   */
  Post: (data: ICompetencyPeriodAssignmentsModel): Promise<ICompetencyPeriodAssignmentsModel> =>
    client.post(`${ApiPath}`, data),
};
